import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import { PARAMETERS_INIT_FAIL, COVERAGE_INIT_LOADING, COVERAGE_INIT_SUCCESS, COVERAGE_INIT_FAIL, CLAUSELIST } from '@/store/types'
export const coverage = {
  async coverageInit({ commit, state }) {
    const apiUrl = state.menu.coverage
    if (apiUrl) {
      commit(COVERAGE_INIT_LOADING)
      try {
        let result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }

        // clause list
        const apiURI = commitResult.menu.getClauses
        result = await http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          commit(CLAUSELIST, data)
        }
        commit(COVERAGE_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(COVERAGE_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(PARAMETERS_INIT_FAIL, extractMessages(['Invalid API URL']))
    }
  }
}
